import { render } from "./GroupPassingsTable.vue?vue&type=template&id=366e9c43&scoped=true"
import script from "./GroupPassingsTable.vue?vue&type=script&lang=js"
export * from "./GroupPassingsTable.vue?vue&type=script&lang=js"

import "./GroupPassingsTable.vue?vue&type=style&index=0&id=366e9c43&lang=scss"
import "./GroupPassingsTable.vue?vue&type=style&index=1&id=366e9c43&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-366e9c43"]])

export default __exports__